import { isGlobalProject } from 'config';

import { CountryRiskBadgesProps } from './CountryRiskBadges';
import { CountryRiskField } from './types';

/**
 * Country of the main address with its badge field, chosen together by project:
 * the residential address in Global, the registration address in Finance
 */
export const getMainAddressCountryRisk = (
  residentialCountry: CountryRiskBadgesProps['country'],
  registrationCountry: CountryRiskBadgesProps['country']
): Pick<CountryRiskBadgesProps, 'country' | 'field'> =>
  isGlobalProject()
    ? {
        country: residentialCountry,
        field: CountryRiskField.ResidentialAddress,
      }
    : {
        country: registrationCountry,
        field: CountryRiskField.RegistrationAddress,
      };
